import { FAKE, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { createSignal } from '@cloudsuite/mosaic-shared/scripts/signals.js'


const [getMollieStartPaymentUrl, setMollieStartPaymentUrl] = createSignal<URL | null>(null)
const [getMollieSelectPaymentMethodUrl, setMollieSelectPaymentMethodUrl] = createSignal<URL | null>(null)
const [getOnAccountStartPaymentUrl, setOnAccountStartPaymentUrl] = createSignal<URL | null>(null)
const [getOnAccountSelectPaymentMethodUrl, setOnAccountSelectPaymentMethodUrl] = createSignal<URL | null>(null)
const [getOverruleStartPaymentUrl, setOverruleStartPaymentUrl] = createSignal<URL | null>(null)
const [getOverruleSelectPaymentMethodUrl, setOverruleSelectPaymentMethodUrl] = createSignal<URL | null>(null)

export const PAYMENT_URL_MUTATOR = Symbol('PAYMENT_URL_MUTATOR')
export type PaymentUrlMutator = {
  setMollieUrls: (startPaymentUrl: URL, selectPaymentMethodUrl: URL) => void
  setOnAccountUrls: (startPaymentUrl: URL, selectPaymentMethodUrl: URL) => void
  setOverruleUrls: (startPaymentUrl: URL, selectPaymentMethodUrl: URL) => void
}

@registerDependency(REAL, PAYMENT_URL_MUTATOR)
@registerDependency(FAKE, PAYMENT_URL_MUTATOR)
export class ConcretePaymentUrlMutator implements PaymentUrlMutator {
  setMollieUrls = (startPaymentUrl: URL, selectPaymentMethodUrl: URL) => {
    setMollieStartPaymentUrl(startPaymentUrl)
    setMollieSelectPaymentMethodUrl(selectPaymentMethodUrl)
  }
  setOnAccountUrls = (startPaymentUrl: URL, selectPaymentMethodUrl: URL) => {
    setOnAccountStartPaymentUrl(startPaymentUrl)
    setOnAccountSelectPaymentMethodUrl(selectPaymentMethodUrl)
  }
  setOverruleUrls = (startPaymentUrl: URL, selectPaymentMethodUrl: URL) => {
    setOverruleStartPaymentUrl(startPaymentUrl)
    setOverruleSelectPaymentMethodUrl(selectPaymentMethodUrl)
  }
}


export const PAYMENT_URL_STORE = Symbol('PAYMENT_URL_STORE')
export type PaymentUrlStore = {
  mollie: {
    startPaymentUrl: URL
    selectPaymentMethodUrl: URL
  }
  onAccount: {
    startPaymentUrl: URL
    selectPaymentMethodUrl: URL
  }
  overrule: {
    startPaymentUrl: URL
    selectPaymentMethodUrl: URL
  }
}

@registerDependency(REAL, PAYMENT_URL_STORE)
@registerDependency(FAKE, PAYMENT_URL_STORE)
export class ConcretePaymentUrlStore implements PaymentUrlStore {
  mollie = {
    get startPaymentUrl() {
      const startPaymentUrl = getMollieStartPaymentUrl()
      if (startPaymentUrl === null) {
        throw Error('Start Payment Url not defined for Mollie')
      }

      return startPaymentUrl
    },
    get selectPaymentMethodUrl() {
      const selectPaymentMethodUrl = getMollieSelectPaymentMethodUrl()
      if (selectPaymentMethodUrl === null) {
        throw Error('Select Payment Method Url not defined for Mollie')
      }

      return selectPaymentMethodUrl
    }
  }
  onAccount = {
    get startPaymentUrl() {
      const startPaymentUrl = getOnAccountStartPaymentUrl()
      if (startPaymentUrl === null) {
        throw Error('Start Payment Url not defined for on Account')
      }

      return startPaymentUrl
    },
    get selectPaymentMethodUrl() {
      const selectPaymentMethodUrl = getOnAccountSelectPaymentMethodUrl()
      if (selectPaymentMethodUrl === null) {
        throw Error('Select Payment Method Url not defined for on Account')
      }

      return selectPaymentMethodUrl
    }
  }
  overrule = {
    get startPaymentUrl() {
      const startPaymentUrl = getOverruleStartPaymentUrl()
      if (startPaymentUrl === null) {
        throw Error('Start Payment Url not defined for overrule')
      }

      return startPaymentUrl
    },
    get selectPaymentMethodUrl() {
      const selectPaymentMethodUrl = getOverruleSelectPaymentMethodUrl()
      if (selectPaymentMethodUrl === null) {
        throw Error('Select Payment Method Url not defined for overrule')
      }

      return selectPaymentMethodUrl
    }
  }
}
